var App = App || {};

App.WidgetCarousel = (function ($) {
    'use strict';

    function Init(selector) {

        if (selector.length) {
            Carousel(selector.find(".splide"));
            Counter(selector.find(".widget-carousel-counter"));
        }
    }

    function Carousel(carousel) {
        if (carousel.length) {
            const options = {
                type: 'loop',
                speed: 500,
                arrows: false,
                pagination: true,
                gap: '3rem',
                mediaQuery: 'min',
                breakpoints: {
                    992: {
                        padding: { right: '20%' },
                        gap: '8rem',
                    }
                }

            };

            var splide = new Splide(carousel[0], options);
            splide.mount({});
        }
    }

    function Counter(counter) {
        if (counter.length) {

            const optionsBase = { useGrouping: true, separator: ',', enableScrollSpy: true };
            const items = counter.find(".item-counter-number");

            items.each(function () {

                const end = $(this).data("counter-end");
                const start = $(this).data("counter-start");
                const dollars = $(this).data("counter-dollars");

                const options = {
                    ...optionsBase,
                    startVal: start,
                    prefix: dollars ? '$' : ''
                };
                var numAnim = new countUp.CountUp(this, end, options);
                numAnim.start()
            });

        }
    }

    return {
        Init: Init
    };

})(jQuery);